import { SHOWCASE_ICONS } from "@/lib/gp";
import { Badge } from "@/components/ui/badge";

function ShowcaseCard({ g, onAsk }) {
  const Icon = SHOWCASE_ICONS[g.id] || SHOWCASE_ICONS.default;
  return (
    <button
      onClick={() => onAsk?.(g)}
      data-testid={`showcase-card-${g.id}`}
      className="group relative w-full text-left rounded-2xl overflow-hidden ring-1 ring-white/10 hover:ring-white/25 transition-all hover:-translate-y-1"
      style={{ boxShadow: `0 0 0 rgba(0,0,0,0)` }}
    >
      <div className="absolute inset-0">
        <img src={g.image} alt={g.name} className="h-full w-full object-cover opacity-40 group-hover:opacity-55 transition-opacity" />
        <div className="absolute inset-0 bg-gradient-to-t from-gp-deep via-gp-deep/80 to-transparent" />
      </div>
      <div className="relative p-4">
        <div className="flex items-center gap-2">
          <span
            className="grid place-items-center h-8 w-8 rounded-lg"
            style={{ background: `${g.accent}22`, color: g.accent }}
          >
            <Icon size={16} />
          </span>
          <span className="text-[11px] uppercase tracking-widest text-white/50">{g.genre}</span>
        </div>
        <h4 className="mt-3 font-unbounded font-bold text-base leading-tight">{g.name}</h4>
        <p className="mt-1 text-xs text-white/60 leading-relaxed line-clamp-2">{g.blurb}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {g.tags.slice(0, 3).map((t) => (
            <Badge key={t} variant="outline" className="border-white/15 bg-white/5 text-[10px] text-white/70 rounded-full">
              {t}
            </Badge>
          ))}
        </div>
      </div>
    </button>
  );
}

export default function ShowcaseSidebar({ games, onAsk }) {
  const hasGames = Boolean(games?.length);
  const loop = hasGames ? [...games, ...games] : [];
  return (
    <aside className="hidden lg:block w-[320px] shrink-0" data-testid="showcase-sidebar" aria-busy={!hasGames}>
      <div className="sticky top-24">
        <div className="flex items-center justify-between mb-3 px-1">
          <h3 className="font-vt323 uppercase tracking-widest text-lg text-gp-gold">Now Trending</h3>
          <span className="text-[10px] uppercase tracking-widest text-white/40">Auto-rotating</span>
        </div>
        <div className="relative h-[560px] overflow-hidden marquee-mask">
          <div className="flex flex-col gap-4 animate-marquee-y hover:[animation-play-state:paused]">
            {loop.map((g, i) => (
              <ShowcaseCard key={`${g.id}-${i}`} g={g} onAsk={onAsk} />
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
}
